import { render } from "./VitalStatus.vue?vue&type=template&id=6cc3aeb2"
import script from "./VitalStatus.vue?vue&type=script&lang=js"
export * from "./VitalStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__